module.exports = __webpack_public_path__ + "img/shockley@x1.bbc055f2.jpeg";